import Script from 'next/script';

const ConversionTagScript = () => {
  return process.env.NEXT_PUBLIC_ENGAGE_BOT_UQID && process.env.NEXT_PUBLIC_ENGAGE_BOT_GID ? (
    <Script id="conversion-tag" strategy="afterInteractive" type="text/javascript">
      {`
        (function () {
          const uqid = '${process.env.NEXT_PUBLIC_ENGAGE_BOT_UQID}';
          const gid = '${process.env.NEXT_PUBLIC_ENGAGE_BOT_GID}';
          const a = document.createElement('script'); 
          a.dataset.uqid = uqid;
          a.dataset.gid = gid;
          a.id = 'afadfpc-${process.env.NEXT_PUBLIC_ENGAGE_BOT_UQID}gid${process.env.NEXT_PUBLIC_ENGAGE_BOT_GID}' + Date.now();
          a.src = '//ac.eb.react.tokyo/fpc/cookie_js.php?scriptId=' + encodeURIComponent(a.id);
          document.head.appendChild(a);
        })();
      `}
    </Script>
  ) : null;
};

export default ConversionTagScript;
